import { FC } from 'react'

import { Routes } from 'common/constants'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'

import { ProductBr } from './product-br'
import { ProductUs } from './product'

export const ProductDetails: FC = () => {
  const { userSelectedEntity } = useAppContext()

  useScreenFinishLoadTac({
    name: 'ProductDetails',
    screen: Routes.NOTIFICATIONS_MANAGEMENT,
    action: 'ProductDetailsFinishLoad',
    entity: userSelectedEntity,
    shouldSend: true,
    logLabel: 'send product details finish tac',
  })

  const isUS = userSelectedEntity === 'US_BRANCH'
  const Product = isUS ? ProductUs : ProductBr

  return <Product />
}
